import { useMemo, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './Radio.module.css';

const UID = () => {
    return 'xxxx-xxxx-xxx-xxxx'.replace(/[x]/g, () => {
        const r = Math.floor(Math.random() * 16);
        return r.toString(16);
    });
};

const useUID = () => useMemo(() => UID(), []);

type RadioProps = {
    label?: JSX.Element;
    labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
    wrapperClassName?: string;
    frame?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
    (
        {
            label,
            wrapperClassName,
            frame,
            disabled,
            className,
            ...inputProps
        }: RadioProps,
        ref
    ) => {
        const UID = useUID();

        return (
            <div
                className={classNames(
                    styles.formWrapper,
                    {
                        [styles.frame]: frame
                    },
                    wrapperClassName
                )}
            >
                <input
                    type="radio"
                    className={classNames(styles.radio, className)}
                    disabled={disabled}
                    ref={ref}
                    id={UID}
                    {...inputProps}
                />
                {label}
            </div>
        );
    }
);

Radio.displayName = 'Radio';
